module.exports = __webpack_public_path__ + "static/media/LoaderDNA_dark.307702b3.gif";